import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { HeadingContent } from '../../types/HeadingContent';

@Component({
  tag: 'cmm-heading-section',
  shadow: false,
})
export class HeadingSection implements ComponentInterface {
  @Prop() content: HeadingContent = null;

  public render(): JSX.Element {
    return (
      <Host>
        <div class="heading-section">
          {this.content?.title ? (
            <wb7-heading class="main-title" size="xs">
              {this.content.title}
            </wb7-heading>
          ) : (
            ''
          )}
          {this.content?.description && Array.isArray(this.content?.description)
            ? this.content?.description.map((paragraph) => (
                <wb7-text class="main-description" size="l" tag="p" innerHTML={paragraph}></wb7-text>
              ))
            : ''}
        </div>
      </Host>
    );
  }
}
